module.exports = __webpack_public_path__ + "static/img/page42.b3cd175.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page42.png
// module id = 3hno
// module chunks = 0